import { render, staticRenderFns } from "./LockerDetail.vue?vue&type=template&id=5346c1c8&scoped=true&"
import script from "./LockerDetail.vue?vue&type=script&lang=js&"
export * from "./LockerDetail.vue?vue&type=script&lang=js&"
import style0 from "./LockerDetail.vue?vue&type=style&index=0&id=5346c1c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5346c1c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCol,VContainer,VRow,VToolbar,VToolbarTitle})
